export const APPROVE = 'Approve'
export const REQUEST = 'Request'
export const REQUEST_MODAL_TITLE = 'Request supplier details'
export const REQUEST_MODAL_DESCRIPTION = 'Click "Request" for supplier details.'
export const REQUEST_MODAL_SEND_EMAIL =
  'Be sure to send an email to the supplier explaining what data is missing or incorrect.'
export const APPROVED_MODAL_TITLE = 'Confirm your approval'
export const APPROVED_MODAL_DESCRIPTION =
  'Are you sure you want to confirm your approval?'
export const APPROVED_MODAL_SUCCESS_NOTIFICATION =
  'Profile was successfully approved'
export const REQUEST_MODAL_SUCCESS_NOTIFICATION =
  'Supplier details were successfully requested'
